import { isNotFound } from './apiError';
import { UserListResponse } from './commonResponse';
import { patch, post } from './request';

export type ChatGroupRoomListResponse = {
    id: number;
    name: string;
    is_lock: boolean;
    users: UserListResponse[];
};

// the maximum value of limit params of search API
export const MAX_SEARCH_API_LIMIT = 30;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const ChatGroupRoomApi = (groupId: number) => {
    const baseUrl = process.env.REACT_APP_COCALERO_API_URL + `/v2/web/chat_groups/${groupId}/chat_group_rooms`;

    return {
        search: (offset: number, limit: number): Promise<ChatGroupRoomListResponse[]> =>
            post(baseUrl + '/search', {
                chat_group_room: {
                    offset: offset,
                    limit: limit,
                },
            })
                .then((res: { chat_group_rooms: ChatGroupRoomListResponse[] }) => res.chat_group_rooms)
                .catch((err: Error) => {
                    if (isNotFound(err)) {
                        return Promise.resolve([]);
                    }
                    return Promise.reject(err);
                }),

        batchGet: (ids: number[]): Promise<ChatGroupRoomListResponse[]> =>
            post(baseUrl + '/search', {
                chat_group_room: {
                    offset: 0,
                    limit: ids.length,
                    id: ids,
                },
            })
                .then((res: { chat_group_rooms: ChatGroupRoomListResponse[] }) => res.chat_group_rooms)
                .catch((err: Error) => {
                    if (isNotFound(err)) {
                        return Promise.resolve([]);
                    }
                    return Promise.reject(err);
                }),

        lock: (roomId: number, isLock: boolean): Promise<ChatGroupRoomListResponse> =>
            patch(baseUrl + `/${roomId}`, {
                chat_group_room: { is_lock: isLock },
            }).then((res: { chat_group_room: ChatGroupRoomListResponse }) => res.chat_group_room),
    };
};
